export function raise(message: string): never {
  throw new Error(message);
}

export function fail(message: string): never {
  throw new Error(message);
}
